var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 131.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Sfumatura_senza_nome_7);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Sfumatura_senza_nome_7-2);\n      }\n\n      .cls-3 {\n        fill: #000;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_7",
    "data-name": "Sfumatura senza nome 7",
    x1: 51.94,
    y1: 83.49,
    x2: 114.61,
    y2: 83.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009db7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ba945f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e84f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_7-2",
    "data-name": "Sfumatura senza nome 7",
    x1: 39.67,
    y1: 39.98,
    x2: 122.34,
    y2: 39.98,
    xlinkHref: "#Sfumatura_senza_nome_7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.84,55.27h4.88v11.76h4.44l6.44-11.76h5.6l-7.92,13.57v.15l9.16,14.29h-5.56l-7.72-12.4h-4.44v12.4h-4.88v-28.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165.04,74.34v-3.66h16.2v3.66h-16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.94,82.3c-1.77-1.03-3.12-2.54-4.04-4.54s-1.38-4.52-1.38-7.56v-1.85c0-3.02.45-5.53,1.36-7.54.91-2.01,2.25-3.52,4.04-4.52,1.79-1.01,3.99-1.51,6.6-1.51s4.78.46,6.5,1.38c1.72.92,3.01,2.15,3.86,3.69.85,1.55,1.31,3.31,1.36,5.3v.23h-4.8v-.11c-.11-1.28-.41-2.4-.92-3.35-.51-.95-1.25-1.72-2.24-2.28-.99-.57-2.23-.85-3.72-.85s-2.77.35-3.82,1.04c-1.05.69-1.85,1.72-2.4,3.09s-.82,3.11-.82,5.22v2.26c0,2.14.27,3.9.82,5.3.55,1.4,1.34,2.43,2.38,3.09,1.04.67,2.31,1,3.8,1s2.7-.25,3.7-.74,1.77-1.22,2.32-2.19c.55-.97.85-2.14.9-3.53v-.11h4.88v.15c-.05,2.04-.51,3.84-1.36,5.41-.85,1.57-2.15,2.81-3.88,3.71-1.73.91-3.91,1.36-6.52,1.36s-4.85-.52-6.62-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.5,82.3c-1.8-1.03-3.17-2.56-4.1-4.6-.93-2.04-1.4-4.61-1.4-7.73v-1.47c0-3.07.47-5.62,1.4-7.65.93-2.04,2.29-3.56,4.08-4.56,1.79-1.01,4.03-1.51,6.72-1.51s4.99.5,6.8,1.51c1.81,1,3.17,2.53,4.06,4.56.89,2.04,1.34,4.59,1.34,7.65v1.47c0,3.12-.45,5.69-1.34,7.73-.89,2.04-2.24,3.57-4.04,4.6-1.8,1.03-4.05,1.54-6.74,1.54s-4.98-.52-6.78-1.54ZM230.24,78.75c1.07-.68,1.88-1.74,2.44-3.18.56-1.45.84-3.25.84-5.41v-1.88c0-2.13-.28-3.91-.84-5.31-.56-1.41-1.37-2.45-2.44-3.13-1.07-.68-2.39-1.02-3.96-1.02s-2.95.34-4.04,1.02c-1.09.68-1.91,1.72-2.44,3.13-.53,1.41-.8,3.18-.8,5.31v1.88c0,2.16.27,3.96.8,5.41.53,1.45,1.35,2.51,2.44,3.18,1.09.68,2.44,1.02,4.04,1.02s2.89-.34,3.96-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.8,55.27h4.84l12.88,19.3,1.2,2.19h.08l-.2-2.53-.12-18.96h4.68v28.01h-4.88l-12.84-19.22-1.12-2.19h-.08l.12,2.49.08,18.92h-4.64v-28.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.28,59.23h-8.48v-3.96h21.96v3.96h-8.48v24.05h-5v-24.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.4,55.27h11.36c3.36,0,5.87.67,7.52,2.02,1.65,1.35,2.48,3.31,2.48,5.9v.26c0,1.86-.49,3.4-1.46,4.62-.97,1.22-2.31,1.99-4.02,2.32v.04c.91.23,1.68.6,2.32,1.11.64.52,1.15,1.17,1.52,1.98.37.8.65,1.75.84,2.83l.4,2.87c.11.9.25,1.69.44,2.36.19.67.41,1.24.68,1.72h-5c-.16-.45-.33-1.02-.52-1.7-.19-.68-.36-1.57-.52-2.68l-.52-2.87c-.16-.78-.43-1.41-.82-1.9-.39-.49-.96-.87-1.72-1.13-.76-.26-1.73-.39-2.9-.39h-5.2v10.67h-4.88v-28.01ZM311.36,67.46c.99-.79,1.48-1.99,1.48-3.6v-.3c0-1.41-.43-2.48-1.3-3.22-.87-.74-2.18-1.11-3.94-1.11h-6.32v9.42h5.96c1.76,0,3.13-.4,4.12-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.06,82.3c-1.8-1.03-3.17-2.56-4.1-4.6s-1.4-4.61-1.4-7.73v-1.47c0-3.07.47-5.62,1.4-7.65s2.29-3.56,4.08-4.56c1.79-1.01,4.03-1.51,6.72-1.51s4.99.5,6.8,1.51c1.81,1,3.17,2.53,4.06,4.56.89,2.04,1.34,4.59,1.34,7.65v1.47c0,3.12-.45,5.69-1.34,7.73-.89,2.04-2.24,3.57-4.04,4.6-1.8,1.03-4.05,1.54-6.74,1.54s-4.98-.52-6.78-1.54ZM337.8,78.75c1.07-.68,1.88-1.74,2.44-3.18s.84-3.25.84-5.41v-1.88c0-2.13-.28-3.91-.84-5.31s-1.37-2.45-2.44-3.13c-1.07-.68-2.39-1.02-3.96-1.02s-2.95.34-4.04,1.02c-1.09.68-1.91,1.72-2.44,3.13s-.8,3.18-.8,5.31v1.88c0,2.16.27,3.96.8,5.41s1.35,2.51,2.44,3.18,2.44,1.02,4.04,1.02,2.89-.34,3.96-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.36,55.27h4.88v24.05h13.12v3.96h-18v-28.01Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.61 104.74 51.94 104.74 58.01 98.61 108.49 98.61 108.49 62.24 114.61 66.02 114.61 104.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.01,85.6l8.67-34.25h13.61l-2.17,8.87c-.21.85-.44,1.69-.67,2.51s-.49,1.65-.78,2.51c.67-1.09,1.48-2.26,2.45-3.49.14-.18.24-.31.3-.38l7.58-10.01h16.98l-15.79,18.2,6.58,16.04h-15.06l-3.47-9.86c-.04-.12-.12-.35-.23-.7-.4-1.15-.72-2.17-.96-3.04-.11.75-.24,1.46-.37,2.11-.14.66-.29,1.31-.46,1.96l-2.39,9.52h-13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.88,47.84l-3.98-2.46-5.1-3.16-21.44-13.25-7.37-4.56c-.98-.6-2.21-.61-3.2-.01l-7.54,4.57-22.06,13.36-5.1,3.09-3.95,2.4c-1.45.88-1.91,2.76-1.03,4.21.58.95,1.59,1.48,2.62,1.48.54,0,1.09-.14,1.58-.44l.78-.47,5.1-3.09,31.17-18.89,30.43,18.82,5.1,3.16.76.47c1.44.89,3.33.44,4.21-.99.89-1.44.44-3.33-.99-4.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.40ee3e88a003ab0a5ad0564ae93207d5.svg";
export { ForwardRef as ReactComponent };